import { render, staticRenderFns } from "./Refund6DescriptionPage.vue?vue&type=template&id=52ce0fcf"
import script from "./Refund6DescriptionPage.vue?vue&type=script&lang=js"
export * from "./Refund6DescriptionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports